import _partition from 'lodash/partition';
import * as Typings from 'components/onboarding/typings';

export default function reorderTasks(categoryList: Typings.TaskCategoryList) {
  const [completeCategories, _incompleteCategories] = _partition(
    categoryList,
    c => c.completionPercentage === 1,
  );

  // expand first incompleteCategory
  const incompleteCategories = _incompleteCategories.length
    ? [{ ..._incompleteCategories[0], isExpanded: true }, ..._incompleteCategories.slice(1)]
    : [];

  return [...incompleteCategories, ...completeCategories].map(c => {
    const [completeTasks, incompleteTasks] = _partition(c.tasks, t => t.isComplete);

    return {
      ...c,
      tasks: [...incompleteTasks, ...completeTasks],
    };
  });
}
